import { TypeaheadOption } from '@lexical/react/LexicalTypeaheadMenuPlugin';

export class EmojiOption extends TypeaheadOption {
  title: string;
  emoji: string;
  keywords: Array<string>;

  constructor(
    title: string,
    emoji: string,
    options: {
      keywords?: string[];
    }
  ) {
    super(title);
    this.title = title;
    this.emoji = emoji;
    this.keywords = options.keywords || [];
  }
}
